import { bindable, ICustomElementViewModel } from 'aurelia';
import './db-scrollbar-blogpost.scss';

export class DbScrollbarBlogpost implements ICustomElementViewModel {
    @bindable blogpostRef: HTMLElement;
    scrollbarRef: HTMLElement;
    scrollElement: HTMLElement | null = null;

    attached() {
        this.attachScrollListener();
    }

    detaching() {
        this.scrollElement?.removeEventListener('scroll', this.updateProgress);
    }

    attachScrollListener() {
        this.scrollElement = document.querySelector('#main-page-host .simplebar-content-wrapper') as HTMLElement | null;

        if (!this.scrollElement) {
            return;
        }

        this.scrollElement.addEventListener('scroll', this.updateProgress);
        this.updateProgress({ target: this.scrollElement } as Event);
    }

    updateProgress = (event: Event) => {
        const { scrollHeight, scrollTop, clientHeight } = event.target as HTMLElement;

        const maxScrollable = Math.max(scrollHeight - clientHeight, 0);
        const scrollPercentage = maxScrollable > 0 ? (scrollTop / maxScrollable) * 100 : 0;

        const scrollbarElement = this.scrollbarRef;
        if (scrollbarElement) {
            scrollbarElement.style.width = `${scrollPercentage}%`;
        }
    };
}
